import { useEffect, useState } from 'react';

const API_URL = typeof window !== 'undefined' ? window.location.origin : '';

/**
 * Dynamically loads Google Analytics and custom tracking scripts
 * from admin-configured settings stored in MongoDB.
 */
const TrackingScripts = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded) return;
    
    const loadTracking = async () => {
      try {
        const res = await fetch(`${API_URL}/api/tracking-settings`);
        if (!res.ok) return;
        const settings = await res.json();

        // Google Analytics
        if (settings.ga_measurement_id) {
          const gaId = settings.ga_measurement_id.trim();
          if (gaId && !document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            document.head.appendChild(script);

            const inline = document.createElement('script');
            inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`;
            document.head.appendChild(inline);
          }
        }

        // Facebook Pixel
        if (settings.fb_pixel_id) {
          const fbId = settings.fb_pixel_id.trim();
          if (fbId && !document.querySelector('script[data-fb-pixel]')) {
            const fbScript = document.createElement('script');
            fbScript.setAttribute('data-fb-pixel', 'true');
            fbScript.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${fbId}');fbq('track','PageView');`;
            document.head.appendChild(fbScript);
          }
        }

        // Custom head scripts
        if (settings.custom_head_scripts) {
          const custom = settings.custom_head_scripts.trim();
          if (custom && !document.querySelector('script[data-custom-tracking]')) {
            const container = document.createElement('div');
            container.innerHTML = custom;
            Array.from(container.children).forEach(el => {
              if (el.tagName === 'SCRIPT') {
                const s = document.createElement('script');
                if (el.src) { s.src = el.src; s.async = true; }
                else { s.textContent = el.textContent; }
                s.setAttribute('data-custom-tracking', 'true');
                document.head.appendChild(s);
              }
            });
          }
        }
      } catch (e) {
        // Silently fail - tracking is non-critical
      }
      setLoaded(true);
    };

    loadTracking();
  }, [loaded]);

  return null;
};

export default TrackingScripts;
